import React, { useMemo } from 'react'
import * as S from './styles'

interface IHeaderWishlistProps {
    label: any;
    to: string;
    sellerCode: string;
    wishlistId?: string;
    currentBrand: string;
}

const HeaderWishlist: React.FC<IHeaderWishlistProps> = ({ label, to, sellerCode, currentBrand, wishlistId }) => {

    const gaUtmsMemo = useMemo(() => {
        const utms: { [key: string]: string } = {
            utm_campaign: sellerCode,
            utm_source: 'maislojinha',
            utm_medium: wishlistId || '',
            utm_content: currentBrand,
        }
        const objectKeysSize = Object.keys(utms).length

        let newUtmText = ''
        let index = 0

        for (const key in utms) {
            index++
            if (!utms[key]) continue
            newUtmText = `${newUtmText}${key}=${utms[key]}${index !== objectKeysSize ? '&' : ''}`
        }

        return newUtmText
    }, [sellerCode, currentBrand, wishlistId])


    return (
    <S.Container>
        <a href={`${to}?${gaUtmsMemo}`} target={"blank"}>
            <img src={label} alt="logo" className='logo' />
        </a>
    </S.Container>
    )
}


export default HeaderWishlist